/**
 * Created by andrey on 18.08.17.
 */

cleverapps.Lives = function (locationConfig) {
    cleverapps.EventEmitter.call(this);
    this.locationConfig = locationConfig;
};

cleverapps.Lives.prototype = Object.create(cleverapps.EventEmitter.prototype);
cleverapps.Lives.prototype.constructor = cleverapps.Lives;

cleverapps.Lives.prototype.destructor = function () {
    this.purge();
    this.stopRegenerateTimeout();
};

cleverapps.Lives.prototype.isWithEnergy = function () {
    return Boolean(this.locationConfig.usesEnergy);
};

cleverapps.Lives.prototype.hasUnlimitedLives = function () {
    return cleverapps.unlimitedLives && (
        this === LivesHelper.GetMainInstance() && cleverapps.unlimitedLives.checkBuyed()
        || cleverapps.unlimitedLives.permanent);
};

cleverapps.Lives.prototype.getTimeout = function () {
    if (this.isWithEnergy() || cleverapps.config.debugMode) {
        return cleverapps.parseInterval(this.locationConfig.livesTimeout || "3 minutes");
    }
    return cleverapps.parseInterval("30 minutes");
};

cleverapps.Lives.prototype.getMaxLives = function () {
    if (this.isWithEnergy()) {
        if (cleverapps.config.type === "merge2") {
            return 100;
        }

        if (!this.locationConfig.isMain) {
            return 80;
        }

        return 75 + cleverapps.user.currentPhysicalLevel.level * 2;
    }

    if (["olympics", "zenmatch", "woodenblock"].includes(cleverapps.config.name)) {
        return 3;
    }

    return 5;
};

cleverapps.Lives.prototype.processRegenerateState = function (silent) {
    this.stopRegenerateTimeout();

    const timeout = this.getTimeout();

    let regenerated = 0;
    while (this.amount < this.getMaxLives() && this.whenStart && (this.whenStart + timeout) <= Date.now()) {
        this.amount++;
        this.whenStart += timeout;
        regenerated++;
    }

    if (regenerated && (this === cleverapps.lives || this === LivesHelper.main)) {
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.EARN.LIVES}-${this.locationConfig.locationId}_regen`, { value: regenerated });
    }

    const unlimited = this.hasUnlimitedLives();

    if (regenerated && !silent && !unlimited) {
        this.trigger("changeAmount");
    }

    if (this.amount >= this.getMaxLives()) {
        delete this.whenStart;
    } else {
        if (!this.whenStart) {
            this.whenStart = Date.now();
            this.save();
        }

        this.startRegenerateTimeout(silent !== undefined ? silent : unlimited);
    }

    this.processLocalPushes();
};

cleverapps.Lives.prototype.startRegenerateTimeout = function (silent) {
    if (this.finishRegenerateTimeout === undefined) {
        console.log("startRegenerateTimeout", this.calcTimeLeft());
        this.finishRegenerateTimeout = new cleverapps.LongTimeout(this.processRegenerateState.bind(this), this.calcTimeLeft());
        if (!silent) {
            this.trigger("startRegenerate");
        }
    }
};

cleverapps.Lives.prototype.stopRegenerateTimeout = function () {
    clearTimeout(this.finishRegenerateTimeout);
    this.finishRegenerateTimeout = undefined;
};

cleverapps.Lives.prototype.isRegenerateRunning = function () {
    return this.finishRegenerateTimeout !== undefined;
};

cleverapps.Lives.prototype.calcTimeLeft = function () {
    const start = this.whenStart || Date.now();
    const livesTimeout = this.getTimeout();
    const finish = start + livesTimeout;
    let timeout = finish - Date.now();
    if (timeout < 0) {
        timeout = 0;
    }
    if (timeout > livesTimeout) {
        timeout = livesTimeout;
    }
    return timeout;
};

cleverapps.Lives.prototype.isEmpty = function () {
    return this.amount === 0 && !this.hasUnlimitedLives();
};

cleverapps.Lives.prototype.isFull = function () {
    return this.amount >= this.getMaxLives() || this.hasUnlimitedLives();
};

cleverapps.Lives.prototype.give = function (amount, event, silent) {
    amount = amount === undefined ? 1 : amount;
    this.setAmount(this.amount + amount, silent);

    if (event) {
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.EARN.LIVES}-${cleverapps.meta.selectedLocationId()}_${event}`, { value: amount });
    }
};

cleverapps.Lives.prototype.setAmount = function (amount, silent) {
    if (amount < 0) {
        amount = 0;
    }

    const spent = this.amount - amount;

    if (spent > 0) {
        const mission = cleverapps.missionManager.findByType(Mission.TYPE_LIVESFEAST);
        if (mission) {
            mission.update(spent);
        }

        cleverapps.eventBus.trigger("spendEnergy", spent);
    }

    if (this.amount !== amount) {
        this.amount = amount;
        this.save();

        if (spent > 0) {
            cleverapps.pendingRewards.release("lives");
        }

        if (!silent) {
            this.trigger("changeAmount");
        }
    }

    this.processRegenerateState(true);

    if (this.amount < (cleverapps.config.type === "merge2" ? 1 : this.getMaxLives() * 0.2)) {
        if (cleverapps.forces.isShown(Forces.BUY_ENERGY_ICON)) {
            cleverapps.eventBus.trigger("ENERGY_VERY_LOW");
        }

        this.showForce();
    }
};

cleverapps.Lives.prototype.processLocalPushes = cleverapps.timeredThrottle(cleverapps.parseInterval("1 minute"), function () {
    const push = this.locationConfig.withOwnLives ? PUSHES.ENERGY_EXPEDITION : PUSHES.LIVES;

    if (this.isFull()) {
        PushHelper.cancelPush(push);
        return;
    }

    const amount = this.getMaxLives() - this.amount;
    const whenStart = this.whenStart || Date.now();
    const timeout = whenStart + this.getTimeout() * amount - Date.now();
    PushHelper.sendPush(push, timeout);
});

cleverapps.Lives.prototype.reset = function () {
    this.amount = this.getMaxLives();
    this.whenStart = undefined;
    this.processRegenerateState();
    this.save();
};

cleverapps.Lives.prototype.canTake = function (amount) {
    return this.hasUnlimitedLives() || this.amount >= amount;
};

cleverapps.Lives.prototype.take = function (silent) {
    if (cleverapps.config.editorMode) {
        return;
    }

    if (this.amount >= this.getMaxLives()) {
        delete this.whenStart;
    }

    if (this.amount > 0) {
        this.setAmount(this.amount - 1, silent);
    }
};

cleverapps.Lives.prototype.beforeUpdate = function () {
    this.stopRegenerateTimeout();
};

cleverapps.Lives.prototype.getInfo = function () {
    return {
        a: this.amount,
        wc: this.whenStart && cleverapps.compactTime(this.whenStart, { seconds: true })
    };
};

cleverapps.Lives.prototype.updateInfo = function (data, fromServer) {
    this.updateData(data);
    this.processRegenerateState();
    this.save(fromServer);
};

cleverapps.Lives.prototype.save = function (fromServer) {
    if (!this.locationConfig.isMain) {
        this.locationConfig.slot.save("lives", this.getInfo(), fromServer);
        return;
    }

    cleverapps.dataLoader.save(DataLoader.TYPES.LIVES, this.getInfo());
    if (!fromServer) {
        connector.synchronizer.addSendTask("lives");
    }
};
 
cleverapps.Lives.prototype.load = function () {
    let info;

    if (!this.locationConfig.isMain) {
        info = this.locationConfig.slot.load("lives");
    } else {
        info = cleverapps.dataLoader.load(DataLoader.TYPES.LIVES);
    }

    this.updateData(info);
};

cleverapps.Lives.prototype.updateData = function (info) {
    if (info) {
        this.amount = info.a || info.amount || 0;
        this.whenStart = info.wc && cleverapps.expandTime(info.wc, { seconds: true }) || info.ws || info.whenStart;
    } else {
        this.amount = this.getMaxLives();
        this.whenStart = undefined;
    }
};

cleverapps.Lives.prototype.canShowForce = function () {
    if (cleverapps.unlimitedLives) {
        return false;
    }

    return (cleverapps.config.type === "merge2" ? VirtualProducts.buyEnergy20 : VirtualProducts.buyEnergy350)
        && !cleverapps.forces.isShown(Forces.BUY_ENERGY_ICON) && cleverapps.environment.isMainScene()
        && cleverapps.gameLevel && this.locationConfig.isMain;
};

cleverapps.Lives.prototype.showForce = function () {
    if (this.canShowForce()) {
        return cleverapps.menuBar.showForce("LivesItem");
    }
};

cleverapps.Lives.IsLocationWithEnergy = function () {
    return cleverapps.meta.getSelectedLocation().locationConfig.usesEnergy;
};

// Base font for the lives/energy tile description. All cleverapps UIs override it; this is the
// default for any UI that doesn't. Lived in the deleted livesproducttile.js.
cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SHOP_LIVES_PRODUCT_TILE_DESCRIPTION_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    }
});
